import { render, staticRenderFns } from "./GFCP.vue?vue&type=template&id=596bb277&scoped=true"
import script from "./GFCP.vue?vue&type=script&lang=js"
export * from "./GFCP.vue?vue&type=script&lang=js"
import style0 from "./GFCP.vue?vue&type=style&index=0&id=596bb277&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596bb277",
  null
  
)

export default component.exports